<template>
  <DropdownMenu
    :dropped.sync="isDropped"
    :stylings="{
      labelButtonClass: 'AssetTableEdit__label btn btn-success btn-sm',
    }"
    class="AssetTableEdit"
  >
    <span v-if="!isMobile" slot="label">
      {{ $t("global.edit") }}
    </span>
    <span v-if="isMobile" slot="icon">
      <span class="fa fa-cog"></span>
    </span>
    <div slot="dropdown" class="AssetTableEdit__List">
      <form class="" @submit.prevent="updateAssetAndRedirect">
        <label>
          {{
            $t("edit_asset_page.how_much", {
              assetName: asset.name,
              assetSymbol: asset.symbol,
            })
          }}
        </label>

        <input
          type="number"
          class="form-control"
          step="0.000000001"
          v-model="holdings"
          ref="input"
        />

        <button type="submit" class="btn btn-primary mt-3 mr-2">
          <i class="fa fa-check mr-1 mr-sm-2"></i>
          {{ $t("edit_asset_page.save") }}
        </button>
        <button
          @click.prevent="removeAssetAndRedirect()"
          class="btn btn-secondary mt-3"
        >
          <i class="fa fa-trash mr-0 mr-sm-2"></i>
          <span class="d-none d-md-inline hidden-xs-down">
            {{ $t("edit_asset_page.delete") }}
          </span>
        </button>
      </form>
    </div>
  </DropdownMenu>
</template>

<script>
import { mapActions } from "vuex";
import DropdownMenu from "./DropdownMenu.vue";

export default {
  name: "AssetTableEdit",
  components: {
    DropdownMenu,
  },
  props: {
    asset: Object,
    isMobile: Boolean,
  },
  data() {
    return {
      isDropped: false,
      holdings: 0,
    };
  },
  methods: {
    updateAssetAndRedirect() {
      const { asset } = this;
      const holdings = Number(this.holdings);
      this.isDropped = false;
      const assetData = {
        exchId: asset.exchId,
        currencyId: asset.currencyId,
        holdings,
      };
      this.updateAsset(assetData);
    },
    removeAssetAndRedirect() {
      this.removeAsset(this.asset);
    },
    ...mapActions({
      updateAsset: "portfolio/updateAsset",
      removeAsset: "portfolio/removeAsset",
    }),
  },
  mounted() {
    this.holdings = this.asset.holdings;
    this.$refs.input.focus();
    this.$refs.input.select();
  },
};
</script>

<style lang="scss">
@import "~@/scss/mixins";
@import "~@/scss/variables";

.AssetTableEdit {
  margin-left: auto;
  margin-right: auto;
}
.AssetTableEdit__label {
  color: #fff;
  background-color: #5bc0de;
  border-color: #5bc0de;
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: 0.2rem;
  @include breakpoint-manual(max-width, $break-small) {
    color: #636c72;
    background: none;
    border: none;
    padding: 0.1rem 0.25rem;
    font-size: 1.7rem;
    line-height: 1rem;
    &:hover,
    &:active,
    &:focus {
      color: #636c72 !important;
      background: none !important;
    }
  }
}
.AssetTableEdit__List {
  min-width: 270px;
  padding: 5px 10px;
}
</style>
